import { defineMessages } from 'react-intl';

export default defineMessages({
  title: {
    id: 'addProfile.modals..success.title',
    defaultMessage: 'Profile created',
  },
  continue: {
    id: 'AddProfile.modals.success.continue',
    defaultMessage: 'Continue',
  },
  nameFeedback: {
    id: 'AddProfile.modals.success.nameFeedback',
    defaultMessage: 'Profile {name} was created successfully!',
  },
  emailFeedback: {
    id: 'AddProfile.modals.success.emailFeedback',
    defaultMessage: 'An email was sent to the address registered with the access instructions',
  },
});
